import React, { useEffect, useState } from 'react'
import { Collapse, Icon } from 'antd';
import { Row, Widget, FormSelect } from '@digital/ui'
import { useRecoilState, useRecoilValue } from 'recoil';
import { reloadState, solicitacaoIdState, solicitacaoState } from '../../../atoms';
import { EStatusSolicitacaoNaoPrevisto, ETipoNaoPrevisto } from '@app/enums/ENaoPrevisto';
import { getAllProjetoDefinicao } from '@app/api/definicaoProjeto';
import TipoOptions from '@app/types/core.types';
import { getAllCrfProjetoDefinicao } from '@app/api/crf/crfDefinicaoProjeto';
import { updateSolicitacaoNaoPrevisto } from '@app/api/naoPrevistos/solicitacao';



const { Panel } = Collapse

const VincularAoProjeto = () => {
    //recoils
    const solicitacaoId = useRecoilValue(solicitacaoIdState);
    const solicitacao = useRecoilValue(solicitacaoState);
    const [reload, setReload] = useRecoilState(reloadState);
    //states
    const [projetoOptions, setProjetoOptions] = useState<TipoOptions[]>([])

    const onSelect = (value: any, property: string) => {
        if (solicitacao[property] === value) return

        const values = { ...solicitacao, [property]: value }
        updateSolicitacaoNaoPrevisto(values).then((result) => {
            setReload(!reload)
        })
    }

    const getProjetosOptionsCNP = () => {
        getAllProjetoDefinicao(0).then((data) => {
            if (data) {
                const options = (data || []).map((projeto) => ({ text: `${projeto.numero} - ${projeto.codigo} - ${projeto.nome}`, value: projeto.id.toString() }))
                setProjetoOptions(options)
            }
        })
    }

    const getProjetosOptionsONP = () => {
        getAllCrfProjetoDefinicao(0).then((data) => {
            if (data) {
                const options = (data || []).map((projeto) => ({ text: `${projeto.numero} - ${projeto.codigo} - ${projeto.nome}`, value: projeto.id.toString() }))
                setProjetoOptions(options)
            }
        })
    }

    useEffect(() => {
        if (solicitacaoId) {
            if (solicitacao && solicitacao.tipo.toLowerCase() == ETipoNaoPrevisto.CNP.toLowerCase()) {
                getProjetosOptionsCNP()
            }
            if (solicitacao && solicitacao.tipo.toLowerCase() == ETipoNaoPrevisto.ONP.toLowerCase()) {
                getProjetosOptionsONP()
            }
        }
    }, [])

    return (
        <>
            <Collapse bordered={false} defaultActiveKey={['2']} expandIcon={() => <Icon type="arrows-right_4" />}>
                <Panel key="2" header={`Vincular Não Previsto ao Projeto`} style={{ border: 0 }}>
                    <Widget title='' actions={[]} >
                        <Row>
                            <FormSelect
                                span={12}
                                name={
                                    solicitacao.tipo.toLowerCase() == ETipoNaoPrevisto.CNP.toLowerCase() ?
                                        'projetoId' : "crfProjetoId"
                                }
                                label='Projeto'
                                showSearch
                                options={projetoOptions}
                                onSelect={(value: any) => {
                                    const property = solicitacao.tipo.toLowerCase() == ETipoNaoPrevisto.CNP.toLowerCase() ?
                                        'projetoId' : "crfProjetoId"
                                    onSelect(value, property)
                                }}
                                optionFilterProp="children"
                                filterOption={(input, item) => {
                                    return item.props.children.props.id
                                        .toString()
                                        .toLowerCase()
                                        .includes(input.toLowerCase());
                                }}
                                disabled={solicitacao.statusId !== EStatusSolicitacaoNaoPrevisto.VincularNaoPrevistoAoProjeto}
                            />
                        </Row>
                    </Widget>
                </Panel>
            </Collapse>
        </>
    )
}

export default VincularAoProjeto